// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'preview-collapse';

export const Component = () => (
  <>
    <rect width='6' height='13' x='5' y='6' rx='1' />
    <path d='M20.5 21v1h-16v-1h16Zm1.5-1.5v-14a1.5 1.5 0 0 0-1.347-1.492L20.5 4h-16a1.5 1.5 0 0 0-1.492 1.347L3 5.5v14A1.5 1.5 0 0 0 4.5 21v1l-.256-.013a2.501 2.501 0 0 1-2.231-2.231L2 19.5v-14A2.5 2.5 0 0 1 4.5 3h16A2.5 2.5 0 0 1 23 5.5v14a2.5 2.5 0 0 1-2.244 2.487L20.5 22v-1a1.5 1.5 0 0 0 1.5-1.5Z' />
  </>
);

export const viewBox = '0 0 25 25';
